import { render, staticRenderFns } from "./live-player.vue?vue&type=template&id=d64d4132&"
import script from "./live-player.vue?vue&type=script&lang=js&"
export * from "./live-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports